<ng-template #modal let-modal>
    <div class="modal-header bg-light">
        <h4 class="modal-title ">{{ 'home.productHeader.placeBid' | cxTranslate }}</h4>
        <h6 class="modal-title modalsubheader">{{ 'home.productHeader.You' | cxTranslate }}</h6>
    </div>
    <div class="modal-body bg-light">
        <!-- <hr class="hr-border"> -->
        <div>
            <span class="h5 strong line-clamp-single text-center pt-2" title="{{productInfo.name}}">{{productInfo.name }}</span>
        </div>
        <div>
            <span class="" *ngIf="portName != productInfo.portName" class="text-secondary line-clamp-single mt-1 h5 text-center mb-4">{{productInfo.portName}}</span>
        </div>
        <div class="d-flex justify-content-between mb-3">
            <div class="small price-width">
                <div class="small strong">{{ 'home.productHeader.Price(perDMT)' | cxTranslate }}</div>
                <div>
                    <span class="currency-icon position-absolute">{{productInfo.price!=undefined?productInfo.price.currencyIso:''}}&nbsp;</span>
                    <input [(ngModel)]="productInfo.priceValue" (keypress)="checkPriceValidation($event);validateDecimalPointPrice($event)" class="form-control form-control-lg modal-input-field space" appTwoDigitDecimaNumber onkeypress="return event.charCode != 45" preventCutCopyPaste required>

                </div>
                <span class="text-danger  bold " *ngIf='productInfo.priceValue == 0 '>{{ 'home.productHeader.enterprice' | cxTranslate }}</span>
                <!-- <span class="text-danger fs-10 pt-2" *ngIf='productInfo.priceValue < productInfo.minPrice'>{{placemsg}}</span> -->
            </div>
            <div class="small quantity-width">
                <div class="small strong">{{ 'home.productHeader.Quantity(WMT)' | cxTranslate }}</div>
                <div class="right-alignment" *ngIf="!showquantity">
                    <!-- <select [(ngModel)]="quantitySelected" class="form-control form-control-lg round select-width">
                    <option value="{{p}}" *ngFor="let p of quantityRangeArray">{{p}}</option>
                    </select> -->
                    <input *ngIf="!showquantity" allowPositiveAndNegativeNumbers numeric type="text" maxlength="maxLen" min="minQty" max="maxQty" [(ngModel)]="quantitySelected"  (change)="checkValidQty()" class="input-field space bold p-3 border bg-white"   required >
                    
                </div>
                <div class="right-alignment" *ngIf="showquantity">
                    <!-- <select [(ngModel)]="actualQuantitySelected" class="form-control form-control-lg round select-width">
                    <option value="{{actualQuantitySelected}}" >{{actualQuantitySelected}}</option>
                    </select> -->
                    <input allowPositiveAndNegativeNumbers numeric type="text" maxlength="maxLen" min="minQty" max="maxQty" class="input-field space bold p-3 border bg-white"  required >
                    <!-- <p *ngIf="qtyEmptyErr" class="text-danger my-1 md-semibold-font ">Please enter Quantity</p> -->

                </div>
                <p *ngIf="qtyEmptyErr" class="text-danger my-1 md-semibold-font fs-10">{{ 'home.productHeader.qtyRequiredCheck' | cxTranslate }}</p>
                <p *ngIf="qtyValidErr" class="text-danger my-1 md-semibold-font fs-10 ">{{ 'home.productHeader.qtyValidCheck' | cxTranslate }}{{this.productInfo.minimumQty+'-'+this.productInfo.maximumQty}}</p>

            </div>
        </div>

        <div class="form-group">
            <div class="small strong">{{ 'home.productHeader.bindingTerms' | cxTranslate }}</div>
            <textarea class="w-100 form-control text" maxlength="5000" placeholder="{{ 'home.productHeader.bindingTermsPh' | cxTranslate }}" [(ngModel)]="biddingTerms"></textarea>
        </div>
        <div class="d-flex justify-content-mobile-between">
            <div class="col-6 p-0 small">
                <div class="small strong">{{ 'home.productHeader.validityDate' | cxTranslate }}*:</div>
                <form role="form" [formGroup]="form" class="inline-filter date-range-picker-form to" >
                    <fieldset>
                        <!-- <date-range-picker [instanceId]="'secondDateRange'" [options]="secondFieldOptions" [parentFormGroup]="form" [controlName]="'secondDateRange'" (rangeSelected)="onRangeSelected($event)" (datepickerReset)="onReset($event)" #dateRangePicker>
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend"> 
                                    </div>
                                    <input id="secondDateRange" class="form-control form-control-lg bg-white  ff-normal h-40" type="text" [value]="dateRangePicker.range" placeholder="{{ 'home.productHeader.selectDate' | cxTranslate }}" [(ngModel)]="dateSelected" formControlName="secondDateRange" readonly/>
                                </div>
                            </div>
                        </date-range-picker> -->
                        <input type="text" ngbDatepicker #d="ngbDatepicker" [footerTemplate]="footerTemplate" class="form-control form-control-lg date-width" (dateSelect)="onDateSelection($event)" [value]=formatter.format(startDate?startDate:today) (click)="toggle(d)"  />
                        <ng-template #footerTemplate>
                            <hr class="my-0">
                            <button class="btn btn-outline-secondary  btn-sm m-2 float-end " (click)="d.close()">{{ 'home.quote.Close' | cxTranslate }}</button>
                        </ng-template>
                    </fieldset>
                </form>

            </div>

            <div class="col-6 p-0 small">
                <div class="small strong ml-0">{{ 'home.productHeader.validityTime' | cxTranslate }}*:</div>
                <div class="right-alignment">
                    <select [(ngModel)]="timeSelected" (change)="selectTimeFunction()" class="round timeSelect form-control form-control-lg text-black select-width">
              <option value="{{p}}" *ngFor="let p of timeArray">{{p}}</option>
            </select>
                </div>
            </div>
        </div>
        <!-- <span *ngIf="!showDateError" class="modalDateError">Please select Date</span> -->
        <div class="small">{{ 'home.productHeader.timeZone' | cxTranslate }} </div>
        <!-- <hr class='hr-border'> -->
        <div *ngIf="counterOfferError" class="text-danger text-center mt-3 strong ">{{counterOfferErrorValue}}</div>
    </div>
    <div class="modal-footer bg-light">
        <div class="w-100 text-center">
            <p class="mb-2 xs-semibold-font">{{confirmTxt}}</p>
        </div>
        <div class="form-group">
            <!-- <button class="btn btn-block btn-primary" type="submit" (click)="navigateToQuote(productInfo,quantitySelected)" data-dismiss="modal" [disabled]="startDate == null || disabledBtn || productInfo.priceValue =='' || productInfo.priceValue == 0 || productInfo.priceValue < productInfo.minPrice"> -->
                <button class="btn btn-block btn-lg btn-primary" type="submit" (click)="navigateToQuote(productInfo,quantitySelected)" data-dismiss="modal" [disabled]="startDate == null || disabledBtn || productInfo.priceValue =='' || productInfo.priceValue == 0">
          {{ 'home.productHeader.ConfirmBid' | cxTranslate }}
        </button>
            <button class="btn btn-block btn-lg btn-light" type="submit" (click)="close()" data-dismiss="modal">{{ 'home.productHeader.Close' | cxTranslate }}</button>
        </div>
    </div>
</ng-template>